export default {
  message: {
    Tour: {
      continue: "Continuar",
      back: "Voltar",
      finish: "Concluir"
    },
    Login: {
      title: "Entrada de pais",
      sign_in: "Entrar",
      login_fail:
        "Falha na autenticação. Tente novamente ou contacte a escola para obter ajuda com o acesso.",
      forgot_password: "Esqueci a palavra-passe",
      create_account: "Criar conta",
      password: "Palavra-passe",
      confirm_password: "Confirmar palavra-passe",
      password_reminder: "Lembrete de palavra-passe",
      enter_email: "Introduza o seu endereço de email",
      validation_error: "Erro de validação",
      password_reminder_error_no_user_register:
        "O nome de utilizador introduzido não foi encontrado. Tente novamente ou crie uma nova conta.",
      password_reminder_error_no_user: "O nome de utilizador introduzido não foi encontrado.",
      password_reminder_sent: "Foi enviado um email com mais instruções para {email}.",
      password_reminder_sent_message:
        "O email pode demorar alguns minutos a chegar. Verifique também a pasta de spam.",
      password_trouble_email: "Se ainda tiver problemas, contacte {email}.",
      password_trouble_school:
        "Se ainda tiver problemas, contacte a escola para obter ajuda.",
      return_to_sign_in: "Voltar ao início de sessão",
      create_my_account: "Criar a minha conta",
      or_sign_in_with: "OU ENTRE COM",
      password_reset: "Escolha uma nova palavra-passe para a sua conta.",
      password_reset_warning:
        "Se não solicitou a alteração da palavra-passe, contacte imediatamente o administrador da escola.",
      password_update: "Escolher nova palavra-passe",
      password_update_confirm: "Confirmar nova palavra-passe",
      password_update_success: "A sua nova palavra-passe foi guardada."
    },
    AccountSettings: {
      title: "Definições da conta",
      first_name: "Nome",
      last_name: "Apelido",
      email: "Email",
      username: "Nome de utilizador",
      password: "Palavra-passe",
      students: "Alunos",
      teachers: "Professores",
      external_id: "ID externo",
      phone: "Número de telefone",
      phone_required: "O número de telefone é obrigatório",
      edit: "Editar",
      remove: "Remover",
      add: "Adicionar",
      remove_message: "Tem a certeza de que deseja remover este aluno?",
      yes: "Sim",
      no: "Não",
      add_student: "Adicionar aluno",
      close: "Fechar",
      save: "Guardar alterações",
      cancel: "Cancelar",
      student_alert_message: "Deve introduzir pelo menos um aluno.",
      logout: "Sair"
    },
    TrialStatus: {
      title: "Update Trial Status",
      schoolLabel: "School",
      currentStatus: "Current Status",
      newStatus: "New Status",
      updatedSuccess: "Trial status updated successfully",
      updateError: "Failed to update trial status",
      statuses: {
        requested: "Requested",
        pending: "Pending",
        fullfilled: "Fulfilled",
        expired: "Expired",
        cancelled: "Cancelled",
        rejected: "Rejected",
        converted: "Converted"
      }
    },
    Navbar: {
      my_meetings: "As minhas reuniões",
      language: "Português",
      help: "Ajuda",
      account_settings: "Definições da conta",
      user_management: "User Management",
      logout: "Sair"
    },
    SubNavbar: {
      meeting: "Reunião",
      event: "Evento",
      print: "Imprimir",
      email: "Email",
      export: "Exportar"
    },
    ConferenceCard: {
      add_edit_meetings: "Adicionar/Editar reuniões",
      opening: "Abertura",
      closed: "Fechado"
    },
    Agenda: {
      full_agenda: "Agenda completa",
      empty_state_title: "Não encontrámos conferências para si.",
      empty_state_message: "Se tiver alguma questão, contacte o representante da escola.",
      confirmation_modal_title: "Agenda confirmada",
      confirmation_modal_message:
        "A sua agenda foi confirmada com sucesso e foi-lhe enviado um email.",
      complete_button: "Concluído!"
    },
    AgendaCard: {
      room: "Sala indisponível",
      room_with_value: "Sala: {room}",
      virtual_meeting: "Reunião virtual",
      all_conferences: "Todas as conferências",
      conference: "Conferência",
      student: "Aluno",
      meeting_with: "Reunião com",
      date_time: "Data/Hora",
      meeting_type: "Tipo de reunião",
      location: "Localização",
      comment: "Comentário",
      action: "Ação",
      delete: "Eliminar",
      add_comment: "Adicionar comentário",
      join: "Participar na reunião",
      choose_meeting_type: "Escolher tipo de reunião",
      in_person: "Presencial",
      phone: "Telefone",
      callback: "Retorno de chamada",
      virtual: "Virtual",
      hybrid: "Híbrido",
      unavailable: "Indisponível",
      tooltip_translator:
        "O serviço de tradução não é garantido, mas a escola fará todos os esforços para o disponibilizar.",
      translator_requested: "Tradutor solicitado",
      clear_translator: "Limpar pedido de tradutor",
      need_translator: "Precisa de um tradutor?",
      choose_language: "Escolha um idioma"
    },
    ScheduleMatrix: {
      no_teachers_title: "Nenhum professor ou equipa selecionado.",
      no_teachers_message: "Escolha um professor para ver os horários de reunião disponíveis.",
      choose_teachers_button: "Ver professores ou equipas disponíveis",
      choose_student: "Para que aluno?",
      cancel: "Cancelar"
    },
    Matrix: {
      teachers: "Professores",
      agenda: "Rever e continuar"
    },
    DrawerTeachers: {
      teachers: "Professores",
      name: "Nome",
      description: "Descrição",
      student: "Aluno",
      teacher_team: "Professor/Equipa",
      show_more: "Mostrar mais professores",
      show_all: "Mostrar todos os professores da escola",
      selected: "({count}) selecionado(s)",
      closeDrawer: "Continuar para o agendamento",
      search: "Pesquisar professor ou equipa",
      not_available: "Este professor não tem horários de reunião disponíveis em {date}."
    },
    DrawerAgenda: {
      no_meetings_title: "Não tem reuniões agendadas.",
      no_meetings_message: "Depois de escolher um professor e um horário, aparecerá aqui.",
      new_meeting_label: "Novo",
      cancel_button: "Cancelar",
      student_label: "Aluno",
      meeting_type_location: "Tipo/Localização da reunião",
      comment_label: "Comentário",
      save_comment_button: "Guardar comentário",
      confirm_label: "Por favor confirme:",
      confirm_cancel_button: "Sim, cancelar a minha reunião com ",
      do_not_cancel_button: "Não cancelar",
      confirm_agenda_button: "Confirmar esta agenda",
      confirm_agenda_message_line1: "Pode sempre voltar e fazer alterações.",
      confirm_agenda_message_line2: "A sua agenda atual será enviada por email."
    },
    EmailConsent: {
      message:
        "Para proteger a sua privacidade e segurança, precisamos do seu consentimento para enviar comunicações para o seu endereço de email.",
      consent: "Consentir"
    },
    UserManagement: {
      pageTitle: "User Management",
      pageSubtitle:
        "Add and manage school and district staff accounts. Staff sign in with school or district login using this site's account.",
      addUser: "Add user",
      editUser: "Edit user",
      loading: "Loading users…",
      emptyTitle: "No staff users yet",
      emptyMessage: "Use Add user to create a school or district staff account.",
      tableUsername: "Username",
      tableEmail: "Email",
      tableRole: "Role",
      tableActions: "Actions",
      typeSchool: "School",
      typeDistrict: "District",
      roleTeam: "Team",
      roleSchool: "School Admin",
      roleReporter: "School Reporter",
      roleDistrict: "District Admin",
      roleNoIntegration: "School Admin without Integration",
      roleNotSet: "Role not set",
      roleUnknown: "Role ({id})",
      formUsername: "Username",
      formEmail: "Email",
      formPassword: "Password",
      formNewPassword: "New password (optional)",
      formRole: "Role",
      loginHint:
        "Staff sign in with the school portal. District staff may use the district portal subdomain when applicable.",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      confirmDeleteTitle: "Remove this user?",
      confirmDeleteBody:
        "This will remove the staff account from your school. This action cannot be undone.",
      validationRequired: "Please fill in all required fields.",
      createdSuccess: "User created.",
      updatedSuccess: "User updated.",
      deletedSuccess: "User removed.",
      genericError: "Something went wrong. Please try again.",
      changeRoleTitle: "Change role",
      roleUpdatedSuccess: "Role updated.",
      deleteUserAria: "Remove user",
      formSchool: "School",
      validationSchoolRequired: "Please select a school.",
      schoolListEmpty: "No schools are available in this district."
    },
    StudentsDirectory: {
      saveLinkHousehold: "Save link household",
      saveLinkHouseholdNothing: "No changes to save.",
      saveLinkHouseholdSuccess: "Link household updated for {count} students.",
      saveLinkHouseholdError: "Could not update link household.",
      saveLinkHouseholdPartial: "Updated {saved} students; {failed} could not be saved."
    }
  }
};
